import * as CONSTANTS from '../../constants';

export default {

    /**
     * Indicate that the introduction confirmation is being processed.
     *
     * @param state
     */
    [CONSTANTS.INTRODUCTION_CONFIRM_SEND_PENDING] (state) {
        state.confirmation = {...state.confirmation, loading: true, error: false, warning: false, noContent: false};
    },

    /**
     * Indicates that the introduction confirmation was processed successfully.
     *
     * @param state
     */
    [CONSTANTS.INTRODUCTION_CONFIRM_SEND_SUCCESS] (state) {
        state.confirmation = {...state.confirmation, loading: false, error: false, warning: false, noContent: false}
    },

    /**
     * Indicates that the introduction confirmation was processed unsuccessfully.
     *
     * @param state
     */
    [CONSTANTS.INTRODUCTION_CONFIRM_SEND_FAILURE] (state) {
        state.confirmation = {...state.confirmation, loading: false, error: true, warning: false, noContent: false}
    },

    /**
     * Indicates that the introduction confirmation was already processed.
     *
     * @param state
     */
    [CONSTANTS.INTRODUCTION_CONFIRM_SEND_WARNING] (state) {
        state.confirmation = {...state.confirmation, loading: false, error: false, warning: true, noContent: false};
    },

    /**
     * Indicate that the introduction confirmation token did not exist.
     *
     * @param state
     */
    [CONSTANTS.INTRODUCTION_CONFIRM_SEND_NO_CONTENT] (state) {
        state.confirmation = {...state.confirmation, loading: false, error: false, warning: false, noContent: true}
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/introduction/mutations.js